import React from 'react';
import { CTAButton } from './CTAButton';
export function NumbersSection() {
  return <section className="bg-primary-dark py-[100px] px-5" data-id="element-428">
      <div className="max-w-[1040px] mx-auto" data-id="element-429">
        <div className="text-center mb-16" data-id="element-430">
          <h2 className="font-serif text-[36px] md:text-[44px] text-cream-light mb-4" data-id="element-431">
            The Numbers Nobody Taught You
          </h2>
          <p className="font-sans text-[16px] text-cream-light/70 max-w-[600px] mx-auto" data-id="element-432">
            This is not your fault. But it is your problem. And these numbers
            explain why.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-433">
          {/* Card 1 */}
          <div className="bg-white/5 border border-gold-accent/20 rounded-lg p-[36px_24px] transition-all duration-300 hover:border-gold-accent/60 hover:-translate-y-1" data-id="element-434">
            <div className="font-serif text-[42px] md:text-[52px] text-gold-accent leading-none mb-4" data-id="element-435">
              $18.8T
            </div>
            <p className="font-sans text-[14px] text-cream-light/70 leading-relaxed" data-id="element-436">
              Total U.S. household debt right now — a record high broken this
              year.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white/5 border border-gold-accent/20 rounded-lg p-[36px_24px] transition-all duration-300 hover:border-gold-accent/60 hover:-translate-y-1" data-id="element-437">
            <div className="font-serif text-[42px] md:text-[52px] text-gold-accent leading-none mb-4" data-id="element-438">
              $11,507
            </div>
            <p className="font-sans text-[14px] text-cream-light/70 leading-relaxed" data-id="element-439">
              Average household credit card balance. Higher every single year.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white/5 border border-gold-accent/20 rounded-lg p-[36px_24px] transition-all duration-300 hover:border-gold-accent/60 hover:-translate-y-1" data-id="element-440">
            <div className="font-serif text-[42px] md:text-[52px] text-blood-red leading-none mb-4" data-id="element-441">
              $18,500
            </div>
            <p className="font-sans text-[14px] text-cream-light/70 leading-relaxed" data-id="element-442">
              Interest you'll pay making only minimum payments. Not what you
              borrowed. The EXTRA.
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-white/5 border border-gold-accent/20 rounded-lg p-[36px_24px] transition-all duration-300 hover:border-gold-accent/60 hover:-translate-y-1" data-id="element-443">
            <div className="font-serif text-[42px] md:text-[52px] text-gold-accent leading-none mb-4" data-id="element-444">
              55%
            </div>
            <p className="font-sans text-[14px] text-cream-light/70 leading-relaxed" data-id="element-445">
              Of Americans cannot cover a $500 emergency without going into more
              debt.
            </p>
          </div>
        </div>

        {/* Bills & debt visual */}
        <div className="my-14 max-w-[680px] mx-auto rounded-lg overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.3)] border border-gold-accent/10" data-id="element-446">
          <img src="https://cdn.magicpatterns.com/uploads/h5TtrKCAbW1cW5GsHfTK3k/heylloyd-image-1774830029298.png" alt="$18,500 in overdue bills, medical debt, and credit card statements — the real cost of no system" className="w-full h-auto block" data-id="element-447" />
        </div>

        <div className="max-w-[680px] mx-auto text-center" data-id="element-448">
          <p className="font-sans text-[19px] text-cream-light leading-[1.9] mb-10" data-id="element-449">
            That{' '}
            <span className="font-bold text-gold-accent" data-id="element-450">
              [$18,500 in interest]
            </span>{' '}
            isn't your debt.
            <br data-id="element-451" />
            It's not what you bought.
            <br data-id="element-452" />
            It's not what you borrowed.
            <br data-id="element-453" />
            It's the TAX you pay every month for not having a system.
            <br data-id="element-454" />
            <br data-id="element-455" />
            That's a used car. That's a semester of college. That's ten years of
            family vacations.
            <br data-id="element-456" />
            Being quietly drained from your life — every month — by people who
            designed it that way.
          </p>

          <p className="font-serif text-[22px] italic text-gold-accent leading-relaxed mb-8" data-id="element-457">
            They didn't teach you this in school.
            <br data-id="element-458" />
            Your job doesn't cover it.
            <br data-id="element-459" />
            The financial industry profits from your confusion.
            <br data-id="element-460" />
            <br data-id="element-461" />
            The more overwhelmed you feel, the more minimum payments you make.
            <br data-id="element-462" />
            The more minimums you make, the more interest they collect.
          </p>

          <p className="font-sans text-[18px] font-bold text-cream-light uppercase tracking-wider mb-10" data-id="element-463">
            This ends today.
          </p>

          <CTAButton subText="Stop paying the $18,500 tax · Start tonight" data-id="element-464">
            I'M DONE PAYING THE TAX — $9.99
          </CTAButton>
        </div>
      </div>
    </section>;
}